<template>
	<AppVMenu open-on-hover min-width="579" max-width="579" rounded nudge-bottom="12" nudge-left="298">
		<template v-slot:activator="{ on, attrs }">
			<a v-on="on" v-bind="attrs" class="learn-more" target="_blank" :href="learnMoreLink"> Learn more </a>
		</template>
		<Col class="menu-content-container">
			<Row class="section-title mb-2">What is a “per user connection”?</Row>
			<Row class="section-content mb-4"
				>By default, steps use one connection for everyone using the feature (“one for all”). In some cases, you may need every user to use
				their own connection for a step (“per user connection”). It allows the feature to use a different connection for every user for the
				same step.
			</Row>
			<Row class="section-title mb-2">Why is this useful?</Row>
			<Row class="section-content mb-4">
				It’s all about access and identity. For example, if a feature needs to get data about an email for users, and you don’t have access
				to their inbox - a per user connection can be the solution. Or if you want the feature to send an email on behalf of the user that
				triggered it and not from a centralized email address.
			</Row>
			<Row class="section-title mb-2"> How does it work? </Row>
			<Row class="section-content mb-4">
				Ply creates a setup experience for your users. Before users can use the feature, they will be prompted to connect their account in
				this setup.
			</Row>
			<a class="learn-more-in-docs" target="_blank" :href="learnMoreLink">Learn more in our docs</a>
		</Col>
	</AppVMenu>
</template>

<script>
export default {
	name: 'SuggestCredentialsTypeDialogContentLearnMoreMenu',
	computed: {
		learnMoreLink() {
			return 'https://docs.ply.io/publish-share-and-debug/per-user-connections';
		},
	},
};
</script>

<style scoped lang="scss">
.learn-more {
	font-size: 11px;
	font-weight: 500;
	letter-spacing: 0px;
	text-decoration: none;
	color: var(--primary-font-color);
	border-bottom: 1px dashed var(--primary-font-color);
}
.menu-content-container {
	width: 579px;
	height: 363px;
	border-radius: 8px;
	background: #ffffff;
	border: 1px solid #e8ecf2;
	padding: 24px 26px 38px 21px;
	box-shadow: 0px 3px 6px #00000029;
}
.section-title {
	font-size: 14px;
	font-weight: 600;
	color: #424242;
	letter-spacing: 0px;
}
.section-content {
	font-size: 12px;
	font-weight: 400;
	color: #424242;
	letter-spacing: 0px;
}
.learn-more-in-docs {
	font-size: 14px;
	color: #5858ec;
	font-weight: 400;
	letter-spacing: 0px;
}
</style>
